module.exports = __webpack_public_path__ + "assets/events_crime_white.fb92fc60.svg";